import type { WorkspaceFeatures } from "@insights/contracts";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export type WorkspaceContext = {
  role: string;
  features: WorkspaceFeatures;
};

export function useWorkspaceContext(workspaceId: string | undefined) {
  return useQuery({
    queryKey: ["workspace", workspaceId, "context"],
    enabled: Boolean(workspaceId),
    queryFn: () =>
      api<WorkspaceContext>(`/workspaces/${workspaceId}/context`),
  });
}
